import { gql, useMutation } from '@apollo/client'
import IconContentAdd from '@mui/icons-material/Add'
import IconCancel from '@mui/icons-material/Cancel'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Form, Input } from 'antd'
import PubSub from 'pubsub-js'
import React, { FC, useState } from 'react'
import { Button, Identifier, useNotify, useRefresh } from 'react-admin'

import { Membership, User } from 'shared/types'

type InviteButtonProps = {
  accountId: Identifier
  button?: any
  onChange?: () => void
}

const INVITE_MEMBERS = gql`
  mutation inviteMembers($members: [NewMember!]!) {
    inviteMembers(members: $members) {
      memberships {
        user {
          email
        }
      }
      errors
    }
  }
`

export const TeamInviteButton: FC<InviteButtonProps> = ({ accountId, onChange, button: ButtonProp }) => {
  const [formErrs, setFormErrs] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [saving, setSaving] = useState<boolean>(false)
  const [showDialog, setShowDialog] = useState(false)
  const notify = useNotify()
  const refresh = useRefresh()
  const [form] = Form.useForm()

  const handleClick = () => {
    setShowDialog(true)
  }

  const handleCloseClick = () => {
    setShowDialog(false)
    clearForm()
  }

  const clearForm = () => {
    form.resetFields()
  }

  const handleSignupErrors = (errors: any) => {
    if (errors[0] && errors[0].includes(',')) setFormErrs(errors[0].split(','))
    else setFormErrs(errors)
  }

  const onInviteSuccess = ({
    inviteMembers: { errors, memberships },
  }: {
    inviteMembers: { errors: string[]; memberships: Membership[] }
  }) => {
    if (errors.length > 0) handleSignupErrors(errors)
    else {
      PubSub.publish('account/invite')
      notify('Member was successfully invited!', { type: 'success' })
      refresh()
      clearForm()
    }
  }

  const [invite] = useMutation(INVITE_MEMBERS, {
    onCompleted: onInviteSuccess,
    onError: handleSignupErrors,
  })

  const onFinish = async (values: User) => {
    invite({ variables: { members: [{ accountId, ...values }] } })
  }

  return (
    <>
      {ButtonProp ? (
        React.cloneElement(ButtonProp, { onClick: handleClick })
      ) : (
        <Button onClick={handleClick} label="Invite">
          <IconContentAdd />
        </Button>
      )}

      <Dialog fullWidth open={showDialog} onClose={handleCloseClick} aria-label="Invite Member">
        <DialogTitle>Invite Member</DialogTitle>

        <DialogContent>
          {formErrs.length > 0 && (
            <div style={{ marginBottom: 20, marginTop: 20, color: '#ff4d4f' }}>
              {formErrs.map((e, i) => (
                <div key={i}>{e}</div>
              ))}
            </div>
          )}
          <Form name="invite-member" form={form} onFinish={onFinish}>
            <Form.Item name="email" rules={[{ required: true, message: 'Email required!' }]}>
              <Input type="email" placeholder="mailbox@company.com" />
            </Form.Item>
            <div style={{ display: 'flex' }}>
              <Button
                style={{ marginLeft: 'auto' }}
                label="ra.action.cancel"
                onClick={handleCloseClick}
                disabled={loading}
              >
                <IconCancel />
              </Button>
              <Button type="submit" label="Invite">
                <IconContentAdd />
              </Button>
            </div>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  )
}
